module.exports = __webpack_public_path__ + "static/media/arrow-left-editor.2448a112.svg";